import { SharedConfig } from '../../../common/model/config';

export const productionSharedConfig: SharedConfig = {
  timeout: 30000,
  defaultBrand: 4,
  sentryDSN: 'https://a5f7e1f5b5844946831350fdeaed3ac3@sentry.monitor.onyo.com/26',
};
